import { useEffect } from "react";
import {
  applyHeadBrandingAssets,
  applyInstitutionalBrandingAssets,
  WE_PEDIDOS_LOGO_URL as wePedidosLogo,
} from "../../services/local/institutionalBranding";
import { setDocumentTitle } from "../../services/local/pageTitle";

export default function useWePedidosBranding(
  pageName = "",
  active = true,
  logoUrl = wePedidosLogo
) {
  useEffect(() => {
    if (!active || typeof document === "undefined") return undefined;

    const previousTitle = document.title;
    setDocumentTitle(pageName, "We! pedidos");
    applyHeadBrandingAssets(logoUrl);

    return () => {
      document.title = previousTitle;
      applyInstitutionalBrandingAssets();
    };
  }, [active, logoUrl, pageName]);
}
